export default "__VITE_ASSET__DjZIRTDU__"